import './index.less';
import Login from './Login';

Login.install = function(Vue) {
  Vue.component(Login.name, Login);
};

export default Login;
